import { Grid, Stack, Typography } from "@mui/material";
import {
  Church,
  CurrencyCircleDollar,
  MapPin,
  Users,
  UsersThree
} from "@phosphor-icons/react";
import TotalLocalChurchPattern from "assets/images/denomation-total-local-churches.png";
import MinistersPattern from "assets/images/denomination-ministers.png";
import TotalMembersPattern2 from "assets/images/denomination-total-members-2.png";
import TotalMembersPattern from "assets/images/denomination-total-members.png";
import ZoneRegionPattern from "assets/images/denomination-zones.png";
import { StatInfoCard } from "features/dashboard";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDenominationDashboardStats } from "../api";
import { useDenominationStore } from "../store";

export const DenominationDashboard = () => {
  const selectedDenomination = useDenominationStore(
    state => state.selectedDenomination
  );

  const navigate = useNavigate();

  const { data: dashboardStats } = useDenominationDashboardStats({
    denominationId: selectedDenomination?.id
  });

  const { t } = useTranslation();

  return (
    <Stack py={4}>
      <Stack spacing={1}>
        <Typography sx={{ fontWeight: "bold" }}>
          {selectedDenomination?.name}
        </Typography>
        <Typography variant="subtitle1" sx={{ color: "gray" }}>
          {t("denominations.dashboard.reportDashboard")}
        </Typography>
      </Stack>
      <Grid container spacing={3} mt={5}>
        <Grid item xs={12} md={4}>
          <StatInfoCard
            title={t("denominations.dashboard.totalLocalChurch")}
            subtitle={t("demoninations.dashbord.clickToView")}
            stat={dashboardStats?.total_churches || 0}
            icon={<Church size={24} />}
            color="#f69148"
            background={`url(${TotalMembersPattern}) #f6914866`}
            isDenominationPage={true}
            clickable={true}
            onClick={() => {
              navigate(
                `/denomination-dashboard/${selectedDenomination?.id}/churches`
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatInfoCard
            title={t("denominations.dashboard.totalMissionCenters")}
            subtitle={t("demoninations.dashbord.clickToView")}
            stat={dashboardStats?.total_mission_centers || 0}
            icon={<MapPin size={24} />}
            color="#3078EE"
            background={`url(${TotalLocalChurchPattern}) #3078EE66`}
            isDenominationPage={true}
            clickable={false}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatInfoCard
            title={t("denominations.dashboard.totalMembers")}
            subtitle={t("demoninations.dashbord.clickToView")}
            stat={dashboardStats?.total_members_latest || 0}
            icon={<UsersThree size={24} />}
            color="#3e4784"
            background={`url(${ZoneRegionPattern}) #3e478466`}
            onClick={() => {
              navigate(
                `/denomination-dashboard/${selectedDenomination?.id}/reports/members`
              );
            }}
            isDenominationPage={true}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatInfoCard
            title={t("denominations.dashboard.totalMinisters")}
            subtitle={t("demoninations.dashbord.clickToView")}
            stat={dashboardStats?.total_employees || 0}
            icon={<Users size={24} />}
            color="#7f56d9"
            background={`url(${TotalMembersPattern2}) #7f56d966`}
            isDenominationPage={true}
            clickable={true}
            onClick={() => {
              navigate(
                `/denomination-dashboard/${selectedDenomination?.id}/hr`
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatInfoCard
            title={t("denominations.dashboard.totalAssets")}
            subtitle={t("demoninations.dashbord.clickToView")}
            stat={dashboardStats?.total_assets || 0}
            icon={<CurrencyCircleDollar size={24} />}
            color="#00B0B9"
            background={`url(${MinistersPattern}) #00B0B966`}
            isDenominationPage={true}
            clickable={false}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
